module.exports = __webpack_public_path__ + "0b28710a605aed91211bd25a19081bae.ttf";